import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReference: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReference"><Path d="M19.5 16.5V2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V20" stroke="currentColor"/><Path d="M8 6.5H16" stroke="currentColor"/><Path d="M19.5 15.5H6C5.17157 15.5 4.5 16.1716 4.5 17C4.5 17.8284 5.17157 18.5 6 18.5H19.5V15.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M19.5 18.5H6C5.17157 18.5 4.5 19.1716 4.5 20C4.5 20.8284 5.17157 21.5 6 21.5H19.5V18.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconReference;
